module.exports = __webpack_public_path__ + "e29c5f1c56e6ba28bab86bd5fbc7bae4.png";